export const COLLECTIONS = {
    ORGANIZATIONS: 'organizations',
    MEMBERS: 'members',
    EVENTS: 'events',
    SCHEDULE: 'schedule',
    ASSETS: 'assets',
    ASSET_VERSIONS: 'versions',
    CONTACTS: 'contacts',
    CLIENTS: 'clients',
    CLIENT_CONTACTS: 'clientContacts',
    CREW: 'crew',
    CREW_ASSIGNMENTS: 'crewAssignments',
    CREW_SCHEDULES: 'crewSchedules',
    PRE_PRODUCTION_CREW: 'preProductionCrew',
    PRE_PRODUCTION_TASKS: 'preProductionTasks',
    PRE_PRODUCTION_HOURS: 'preProductionHours',
    FLIGHTS: 'flights',
    HOTELS: 'hotels',
    RENTAL_CARS: 'rentalCars',
    USERS: 'users',
    USER_PREFERENCES: 'userPreferences',
    SLUGS: 'slugs',
    SYSTEM_SETTINGS: 'systemSettings',
    COMMISSION_PAYMENTS: 'commissionPayments',
    ROLE_PERMISSION_CONFIGS: 'rolePermissionConfigs',
    RETAINER_TASKS: 'retainerTasks',
    SPEAKERS: 'speakers',
    EVENT_SPEAKERS: 'eventSpeakers',
    SPONSORS: 'sponsors',
    SPONSOR_ASSETS: 'sponsorAssets',
    EVENT_SPONSORS: 'eventSponsors',
    SPONSOR_TIERS: 'sponsorTiers',
    PORTAL_SUBMISSIONS: 'portalSubmissions',
    SPEAKER_SUBMISSION_FORMS: 'speakerSubmissionForms',
    SPONSOR_SUBMISSION_FORMS: 'sponsorSubmissionForms',
    SESSION_BOOKING_FORMS: 'sessionBookingForms',
    SESSION_SCHEDULE: 'sessionSchedule',
    FINANCE_CACHE: 'financeCache',
    FINANCE_CACHE_QUEUE: 'financeCacheQueue',
    AUDIT_LOGS: 'auditLogs',
    SECURITY_LOGS: 'securityLogs',
    SESSIONS: 'sessions',
    HERO_CARD_TEMPLATES: 'heroCardTemplates',
    HERO_CARDS: 'heroCards',
    CLIENT_CONTRACTS: 'clientContracts',
    AGREEMENT_TEMPLATES: 'agreementTemplates',
    AGREEMENT_SIGNING_REQUESTS: 'agreementSigningRequests',
    SPEAKER_PACKET_TEMPLATES: 'speakerPacketTemplates',
    SPEAKER_PACKET_REQUESTS: 'speakerPacketRequests',
    SPONSOR_PACKET_TEMPLATES: 'sponsorPacketTemplates',
    SPONSOR_PACKET_REQUESTS: 'sponsorPacketRequests',
    BOOKKEEPING_ACCOUNTS: 'bookkeepingAccounts',
    BOOKKEEPING_TRANSACTIONS: 'bookkeepingTransactions',
    TRANSACTION_RULES: 'transactionRules',
    BANK_PROFILES: 'bankProfiles',
    IMPORT_BATCHES: 'importBatches',
    RECONCILIATIONS: 'reconciliations',
    VENDORS_1099: 'vendors1099',
    LEARNED_PATTERNS: 'learnedPatterns',
    BILLS: 'bills',
    PRODUCTION_SCHEDULE: 'productionSchedule',
    CREW_ONBOARDING_TOKENS: 'crewOnboardingTokens',
    FLIGHT_TRACKING: 'flightTracking',
};
export const PERMISSIONS = {
    EVENT_CREATE: 'event.create',
    EVENT_READ: 'event.read',
    EVENT_UPDATE: 'event.update',
    EVENT_DELETE: 'event.delete',
    ASSET_CREATE: 'asset.create',
    ASSET_READ: 'asset.read',
    ASSET_UPDATE: 'asset.update',
    ASSET_DELETE: 'asset.delete',
    ASSET_APPROVE: 'asset.approve',
    SCHEDULE_CREATE: 'schedule.create',
    SCHEDULE_READ: 'schedule.read',
    SCHEDULE_UPDATE: 'schedule.update',
    SCHEDULE_DELETE: 'schedule.delete',
    CONTACT_CREATE: 'contact.create',
    CONTACT_READ: 'contact.read',
    CONTACT_UPDATE: 'contact.update',
    CONTACT_DELETE: 'contact.delete',
    CREW_CREATE: 'crew.create',
    CREW_READ: 'crew.read',
    CREW_UPDATE: 'crew.update',
    CREW_DELETE: 'crew.delete',
    MEMBER_INVITE: 'member.invite',
    MEMBER_REMOVE: 'member.remove',
    MEMBER_UPDATE_ROLE: 'member.update_role',
    ORG_UPDATE: 'org.update',
    ORG_DELETE: 'org.delete',
};
export const ROLE_PERMISSIONS = {
    owner: Object.values(PERMISSIONS),
    administrator: Object.values(PERMISSIONS),
    executive_producer: Object.values(PERMISSIONS), // All permissions (renamed from producer)
    production_manager: [
        PERMISSIONS.EVENT_CREATE,
        PERMISSIONS.EVENT_READ,
        PERMISSIONS.EVENT_UPDATE,
        PERMISSIONS.ASSET_CREATE,
        PERMISSIONS.ASSET_READ,
        PERMISSIONS.ASSET_UPDATE,
        PERMISSIONS.ASSET_APPROVE,
        PERMISSIONS.SCHEDULE_CREATE,
        PERMISSIONS.SCHEDULE_READ,
        PERMISSIONS.SCHEDULE_UPDATE,
        PERMISSIONS.CONTACT_CREATE,
        PERMISSIONS.CONTACT_READ,
        PERMISSIONS.CONTACT_UPDATE,
        PERMISSIONS.CREW_CREATE,
        PERMISSIONS.CREW_READ,
        PERMISSIONS.CREW_UPDATE,
        PERMISSIONS.MEMBER_INVITE,
    ],
    account_manager: [
        PERMISSIONS.EVENT_CREATE,
        PERMISSIONS.EVENT_READ,
        PERMISSIONS.EVENT_UPDATE,
        PERMISSIONS.ASSET_CREATE,
        PERMISSIONS.ASSET_READ,
        PERMISSIONS.ASSET_UPDATE,
        PERMISSIONS.ASSET_APPROVE,
        PERMISSIONS.SCHEDULE_CREATE,
        PERMISSIONS.SCHEDULE_READ,
        PERMISSIONS.SCHEDULE_UPDATE,
        PERMISSIONS.CONTACT_CREATE,
        PERMISSIONS.CONTACT_READ,
        PERMISSIONS.CONTACT_UPDATE,
        PERMISSIONS.CREW_CREATE,
        PERMISSIONS.CREW_READ,
        PERMISSIONS.CREW_UPDATE,
        PERMISSIONS.MEMBER_INVITE,
    ],
    production_coordinator: [
        PERMISSIONS.EVENT_READ,
        PERMISSIONS.ASSET_CREATE,
        PERMISSIONS.ASSET_READ,
        PERMISSIONS.ASSET_UPDATE,
        PERMISSIONS.SCHEDULE_CREATE,
        PERMISSIONS.SCHEDULE_READ,
        PERMISSIONS.SCHEDULE_UPDATE,
        PERMISSIONS.CONTACT_CREATE,
        PERMISSIONS.CONTACT_READ,
        PERMISSIONS.CONTACT_UPDATE,
        PERMISSIONS.CREW_READ,
        PERMISSIONS.CREW_UPDATE,
    ],
    crew_member: [
        PERMISSIONS.EVENT_READ,
        PERMISSIONS.SCHEDULE_READ,
        PERMISSIONS.CREW_READ,
        PERMISSIONS.CONTACT_READ,
    ],
    client: [
        PERMISSIONS.EVENT_READ,
        PERMISSIONS.ASSET_READ,
        PERMISSIONS.SCHEDULE_READ,
        PERMISSIONS.CONTACT_READ,
    ],
    guest: [
        PERMISSIONS.EVENT_READ,
        PERMISSIONS.ASSET_READ,
        PERMISSIONS.SCHEDULE_READ,
        PERMISSIONS.CONTACT_READ,
    ],
    // Legacy role mapping
    producer: [
        PERMISSIONS.EVENT_READ,
        PERMISSIONS.EVENT_UPDATE,
        PERMISSIONS.ASSET_CREATE,
        PERMISSIONS.ASSET_READ,
        PERMISSIONS.ASSET_UPDATE,
        PERMISSIONS.SCHEDULE_CREATE,
        PERMISSIONS.SCHEDULE_READ,
        PERMISSIONS.SCHEDULE_UPDATE,
        PERMISSIONS.CONTACT_READ,
        PERMISSIONS.CREW_READ,
        PERMISSIONS.CREW_UPDATE,
    ],
};
export const PLAN_LIMITS = {
    producer: {
        maxUsers: 5,
        maxEventsPerMonth: -1,
        maxStorageGB: 100,
        features: ['basic_reporting', 'email_support'],
    },
    agency: {
        maxUsers: 25,
        maxEventsPerMonth: -1,
        maxStorageGB: 500,
        features: ['advanced_reporting', 'priority_support', 'api_access', 'custom_branding'],
    },
    enterprise: {
        maxUsers: -1,
        maxEventsPerMonth: -1,
        maxStorageGB: -1,
        features: [
            'advanced_reporting',
            'dedicated_support',
            'api_access',
            'white_label',
            'sso',
            'audit_logs',
        ],
    },
};
export const DEFAULT_SPONSOR_CHECKLIST = [
    { id: 'source', label: 'Source', type: 'auto' },
    { id: 'agreementSigned', label: 'Agreement Signed', type: 'toggle' },
    { id: 'logosApproved', label: 'Approved Logos', type: 'toggle' },
    { id: 'sponsorPacketSent', label: 'Sponsor Packet Sent', type: 'toggle' },
    { id: 'verificationStatus', label: 'Verification Status', type: 'auto' },
];
// Default speaker checklist items (the 6 hardcoded items)
export const DEFAULT_SPEAKER_CHECKLIST = [
    { id: 'source', label: 'Source', type: 'auto' },
    { id: 'agreementSigned', label: 'Agreement Signed', type: 'auto' },
    { id: 'headshotReceived', label: 'Headshot Received', type: 'auto' },
    { id: 'verificationStatus', label: 'Verification Status', type: 'auto' },
    { id: 'calendarInviteSent', label: 'Calendar Invite Sent', type: 'toggle' },
    { id: 'speakerPacketSent', label: 'Speaker Packet Sent', type: 'toggle' },
];
//# sourceMappingURL=constants.js.map